export function formatNumber(number: number | string | null | undefined): string {
  if (number === null || number === undefined) {
    return '';
  }

  const isPositivePrefixed = typeof number === 'string' && number.startsWith('+');

  const parsed = Number(number);
  if (Number.isNaN(parsed)) {
    return String(number);
  }

  const formatted = new Intl.NumberFormat('en-US').format(parsed);

  return isPositivePrefixed ? '+' + formatted : formatted;
}
